var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.669,21a28.4,28.4,0,0,0,1.94-2.624h9.454a1.313,1.313,0,1,0,0-2.625H13.125a3.938,3.938,0,1,1,0-7.875h1.858c-1.233-1.741-1.858-3.066-1.858-3.937a3.937,3.937,0,1,1,7.875,0c0,2.148-3.9,6.518-3.937,6.562H13.125a1.313,1.313,0,1,0,0,2.625h3.937a3.937,3.937,0,0,1,0,7.875ZM15.751,3.938a1.313,1.313,0,1,0,1.312-1.313A1.314,1.314,0,0,0,15.751,3.938ZM3.937,21C3.9,20.955,0,16.575,0,14.438a3.938,3.938,0,1,1,7.875,0c0,2.137-3.9,6.518-3.937,6.562h0ZM2.625,14.438a1.313,1.313,0,1,0,1.312-1.313A1.314,1.314,0,0,0,2.625,14.438Z",
    transform: "translate(-0.5 0.5)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    transform: "translate(-0.5 0.5)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRide);
export default __webpack_public_path__ + "static/media/Ride.4e013d0ae3dbbd32a188e34bdc12f808.svg";
export { ForwardRef as ReactComponent };